import { HttpErrorHandler } from '@spartacus/core';

export const OAUTH_ENDPOINT = '/authorizationserver/oauth/token';

export { HttpErrorHandler };
